import { QueryClient, MutationCache } from '@tanstack/react-query';
import { ApiError, NetworkError, isRetryable } from '../api/error';

const mutationCache = new MutationCache({
  onError(err) {
    if (err instanceof NetworkError) return;
    if (err instanceof ApiError && err.status < 500) return;
    // Lazy import to keep tests decoupled from Sentry
    import('../sentry/index.js').then(({ Sentry }) => Sentry.captureException(err)).catch(() => {});
  },
});

export function createQueryClient() {
  return new QueryClient({
    mutationCache,
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: 'always',
        retry: (failureCount, err) => {
          if (!isRetryable(err)) return false;
          return failureCount < 2;
        },
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

/**
 * Singleton QueryClient for the app.
 *
 * Exported so the auth store can call `queryClient.clear()` on logout
 * to prevent stale data leaking between user sessions.
 * Tests should use `createQueryClient()` to get an isolated instance.
 */
export const queryClient = createQueryClient();
